import { AgencyWiseFareCalculations, PassengerFares } from "./FlightSearchResponseProperties"

export class InsuranceRightsObject {
  agencyId: string = '';
  userId: string = '';
  supplierid: string = '';
  officeid: string = '';
}

export class InsuranceRights {
  issue: boolean = false;
  cancel: boolean = false;
  book: boolean = false;
}
export class RootResponse {
  supplierId: string = "";
  officeId: string = "";
  genericResponse: GenericResponse
}

export interface GenericResponse {
  insuranceTitle: string
  insuranceDesc: string
  totalPlansAvailable: number
  errorCode: string
  errorMessage: string
  availablePlans: AvailablePlan[]
  availablePlansRevenue: AvailablePlanRevenue[]
  availableUpsellPlans: AvailableUpsellPlan[]
}

export class CancelPolicyClass{
  itinerary: string;
  policyno:string;
  pnr: string;
  purchaseDate:string;
}

export interface AvailablePlan {
  planCode: string
  ssrFeeCode: string
  currencyCode: string
  totalPremiumAmount: number
  totalCoverageAmount: number
  planPremiumChargeType: string
  planTitle: string
  planDesc: string
  planMarketingPointers: PlanMarketingPointer[]
  PlanAdditionalInfoTitle: string
  planAdditionalInfoDesc: string
  planYesDesc: string
  planNoDesc: string
  planNoConsideration: string
  planTnC: string
  isDefaultPlan: boolean
  planContent: string
  planQualifiedPassengers: any[]
  planPricingBreakdown: PlanPricingBreakdown[]
  planType: string
}
export interface AvailablePlanRevenue {
  planCode: string
  ssrFeeCode: string
  currencyCode: string
  totalPremiumAmount: number
  totalCoverageAmount: number
  planPremiumChargeType: string
  planTitle: string
  planDesc: string
  planMarketingPointers: PlanMarketingPointer[]
  PlanAdditionalInfoTitle: string
  planAdditionalInfoDesc: string
  planYesDesc: string
  planNoDesc: string
  planNoConsideration: string
  planTnC: string
  isDefaultPlan: boolean
  planContent: string
  planQualifiedPassengers: any[]
  planPricingBreakdown: PlanPricingBreakdown[]
  planType: string
  discount: string
  markup: string
  serviceFee: string
  discountValue: string
  markupValue: string
  serviceFeeValue: string
  baseAmount: string
  taxAmount: string
  vat: string
  totalAmount: string
  agencyWiseFare : AgencyWiseFareCalculations[]; 
}
export interface PlanMarketingPointer {
  pointID: number
  pointDesc: any
}

export interface PlanPricingBreakdown {
  minAge: number
  maxAge: number
  gender: string
  currencyCode: string
  premiumAmount: number
  premiumBreakdown: PremiumBreakdown
}

export interface PremiumBreakdown {
  premiumCharges: PremiumCharges
}

export interface PremiumCharges {
  charges: Charge[]
}

export interface Charge {
  sequenceNo: number
  rateType: string
  percentageValue: string
  amountValue: number
}

export interface AvailableUpsellPlan {
  upsellPlans: UpsellPlan[]
}

export interface UpsellPlan {
  planCode: string
  ssrFeeCode: string
  currencyCode: string
  totalPremiumAmount: number
  totalCoverageAmount: number
  planPremiumChargeType: string
  planTitle: string
  planDesc: string
  planAdditionalInfoTitle: string
  planAdditionalInfoDesc: string
  planYesDesc: string
  planNoDesc: string
  planNoConsideration: string
  planTnC: string
  isDefaultPlan: boolean
  planContent: string
  planQualifiedPassengers: any[]
  planPricingBreakdown: PlanPricingBreakdown2[]
  planType: string
}

export interface PlanPricingBreakdown2 {
  minAge: number
  maxAge: number
  gender: string
  currencyCode: string
  premiumAmount: number
  premiumBreakdown: PremiumBreakdown2
}

export interface PremiumBreakdown2 {
  premiumCharges: PremiumCharges2
}

export interface PremiumCharges2 {
  charges: Charge2[]
}

export interface Charge2 {
  sequenceNo: number
  rateType: string
  percentageValue: string
  amountValue: number
}

export class TravelInsuranceBookedPassengers {
  passengerName: string;
  identityNo: string;
  policyNo: string;
  policyUrlLink: string;
  pnr: string;
  travelFromDate: string;
  travelEndDate: string;
  departCountryCde: string;
  arrivalCountryCode: string;
  createdDate: string;

}

export class TravelInsurancePassengersProperties {
  isInfant: string = "";
  passengerType: number = 0;
  profile_Id: number = 0;
  title: string = "";
  firstName: string = "";
  lastName: string = "";
  gender: string = "";
  identityType: string = "";
  passportNumber: string = "";
  dateOfBirth: Date = new Date();
  age: string = "";
  nationality: string = "";
  isQualified: boolean = true;
  selectedPlanCode: string = "";
  selectedSSRFeeCode: string = "";
  currencyCode: string = "";
  passengerPremiumAmount: number = 0;
}
export class InsuranceFlight {
  departCountryCode: string = "";
  arrivalCountryCode: string = "";
  departAirlineCode: string = "";
  departDatetime: Date = new Date();
}
export class TravelInsurancePlanPurchaseProperties {
  pnr: string = "";
  purchaseDate: Date = new Date();
  ssrFeeCode: string = "";
  currency: string = "";
  totalPremium: number = 0;
  countryCode: string = "";
  totalAdults: number = 0;
  totalChild: number = 0;
  totalInfants: number = 0;
  contactPerson: string = "";
  email: string = "";
  mobile: string = "";
  flights: InsuranceFlight[] = [];
  travelInsurancePassengersProperties: TravelInsurancePassengersProperties[] = [];
}
export class ConfirmPurchaseResponse1 {
  PurchaseResponse: PurchaseResponse;
}
export class PurchaseResponse {
  ProposalState: number | string = 0;
  ItineraryID: string = "";
  ErrorCode: number | string = 0;
  ErrorMessage: string = "";
  PolicyNo: string = "";
  ConfirmedPassengers: ConfirmedPassengers[] = [];
  PNR: string = "";
  PolicyPurchasedFlyDate: string = "";
  PolicyPurchasedDateTime: string = "";
  PremiumAmount: string = "";
  PlanTitle: string = "";
  CreationUser: number = 0;
  IssuanceAgency: string = "";
  TotalPremiumAmount: string = "";
  TotalRevenuePremium: string = "";
  VAT: string = "";
  ServiceFee: string = "";
  Taxes: string = "";
  Discount: string = "";
  Markup: string = "";
  NoOfPassengers: number = 0;
  ServiceFeeValue: string = "";
  DiscountValue: string = "";
  MarkupValue: string = "";
};
export class ConfirmedPassengers {
  ConfirmedPassenger: ConfirmedPassenger = new ConfirmedPassenger();
}

export class ConfirmedPassenger {
  FirstName: string = "";
  LastName: string = "";
  DOB: string = "";
  IdentityNo: string = "";
  PolicyNo: string = "";
  PolicyURLLink: string = "";
}
export class InsuranceIssuanceBaseData {
  purchaseInformation: PurchaseResponse = new PurchaseResponse();
  confirmedPassengers: ConfirmedPassengers[] = [];
}
export class CancelPolicyResponse {
  PolicyResponse: PolicyResponse = new PolicyResponse();
}
export class PolicyResponse {
  
  ItineraryState: string = "";
  ItineraryID: string = "";
  PNR: string = "";
  ErrorCode: string = "";
  ErrorMessage: string = "";
  PolicyNo: string = "";
  PolicyCancelDateTime: string = "";
  PolicyRefundDateTime: string = "";
}
export class DBInsertProps {
  responseObj: ConfirmPurchaseResponse1;
  requestObj: TravelInsurancePlanPurchaseProperties;
  plan: AvailablePlanRevenue;
}


/************************************** United Insurance Properties ***********************************/

export class GetPackagesDetailByTravelPeriodWithCovidRequest {
  username: string | null;
  password: string | null;
  travelerName: string | null;
  nicNo: string | null;
  ntnNo: string | null;
  travelDays: number;
  dob: string | null;
  srvSrce: string | null;
  covid: string | null;
}

export class GetPackagesDetailByTravelPeriodWithCovidResponse {
  usrRecID: string | null;
  fullName: string | null;
  active: string | null;
  responseCode: string | null;
  responseDescription: string | null;
  expDate: string | null;
  email: string | null;
  mobileNo: string | null;
  nicNo: string | null;
  creditBal: number;
  creditConsumed: number;
  balance: number;
  pDays: string | null;
  duration: string | null;
  durationUnit: string | null;
  areaShortCode: string | null;
  area: string | null;
  plan: string | null;
  planType: string | null;
  premium: number;
  agePremIncrease: number;
  grossPremium: number;
  advanceTax: number;
  travelerName: string | null;
  travelerNICNo: string | null;
  travelerNTNNo: string | null;
  isTaxPayer: string | null;
  totalPayablePremium: number;
  travelerDOB: string;
  travelerAge: number;
  passengerFares: PassengerFares;
  supplierId: string = "";
  officeId: string = "";
  // agencyWiseFare: AgencyWiseFareCalculations[] = [];
  // baseAmount: string;
  // discount: string;
  // markup: string;
  // serviceFee: string;
  // discountValue: string;
  // markupValue: string;
  // serviceFeeValue: string;
  // taxAmount: string;
  // vat: string;
  // totalAmount: string;
  // totalMarkupAmount: number;
}

export class GetALLCoveragesDetailRequest {
  username: string | null;
  password: string | null;
  srvSrce: string | null;
}

export class GetALLCoveragesDetailResponse {
  id: string | null;
  benefits: string | null;
  diamondPackage: string | null;
  goldPackage: string | null;
  silverPackage: string | null;
  standardPackage: string | null;
  platinumPackage: string | null;
  goldplusPackage: string | null;
  sapphirePackage: string | null;
  sapphireplusPackage: string | null;
  responseCode: string | null;
  responseDescription: string | null;
}

export class GetCoveragesDetailbyAreaRequest {
  username: string | null;
  password: string | null;
  areaShortCode: string | null;
  srvSrce: string | null;
}

export class GetCoveragesDetailByAreaResponse {
  id: string | null;
  benefits: string | null;
  areaShrotCode: string | null;
  area: string | null;
  packageA: string | null;
  packageB: string | null;
  responseCode: string | null;
  responseDescription: string | null;
}

export class GetCountryDetailbyAreaRequest {
  username: string | null;
  password: string | null;
  areaShortCode: string | null;
  srvSrce: string | null;
}

export class GetCountryDetailbyAreaResponse {
  responseCode: string | null;
  responseDescription: string | null;
  id: string | null;
  areaShortCode: string | null;
  countryName: string | null;
}

export class GenerateUWDocumentRequest {
  username: string | null;
  password: string | null;
  areaShortCode: string | null;
  travelDate: string | null;
  travelerName: string | null;
  noOfDays: string | null;
  dOB: string | null;
  passportNo: string | null;
  nicNo: string | null;
  address: string | null;
  contactNo: string | null;
  beneficiaryName: string | null;
  relationship: string | null;
  country: string | null;
  remarks: string | null;
  planType: string | null;
  plan: string | null;
  premium: string | null;
  nTNNo: string | null;
  travelerEmail: string | null;
  spouseName: string | null;
  spouseDOB: string | null;
  spousePassport: string | null;
  child1Name: string | null;
  child1DOB: string | null;
  child1Passport: string | null;
  child2Name: string | null;
  child2DOB: string | null;
  child2Passport: string | null;
  child3Name: string | null;
  child3DOB: string | null;
  child3Passport: string | null;
  isRequestPolicy: boolean;
  srvSrce: string | null;
  refferenceNo: string | null;
  eSystemName: string | null;
  eUserName: string | null;
  covid: string = "NotCovered";
}

export class GenerateUWDocumentResponse {
  responseCode: string | null;
  responseDescription: string | null;
  referenceID: string | null;
  policyNo: string | null;
  travelerName: string | null;
  amount: string | null;
  advanceTax: string | null;
  travelerEmail: string | null;
  policyPrintURL: string | null;
}

export class GetRequestedUWDocumentDataRequest {
  username: string | null;
  password: string | null;
  datafor: string | null;
  srvSrce: string | null;
}

export class GetRequestedUWDocumentDataResponse {
  requestID: string | null;
  areaShortCode: string | null;
  travelDate: string | null;
  travelerName: string | null;
  noOfDays: string | null;
  dob: string | null;
  passportNo: string | null;
  nICNo: string | null;
  address: string | null;
  contactNo: string | null;
  beneficiaryName: string | null;
  relationship: string | null;
  country: string | null;
  remarks: string | null;
  planType: string | null;
  plan: string | null;
  spouseName: string | null;
  spouseDOB: string | null;
  spousePassport: string | null;
  child1Name: string | null;
  child1DOB: string | null;
  child1Passport: string | null;
  child2Name: string | null;
  child2DOB: string | null;
  child2Passport: string | null;
  child3Name: string | null;
  child3DOB: string | null;
  child3Passport: string | null;
  createdOn: string | null;
  cSystemName: string | null;
  eCreatedUser: string | null;
  modifiedOn: string | null;
  mSystemName: string | null;
  eModifiedUser: string | null;
  referenceNo: string | null;
  premium: string | null;
  advTaxAmount: string | null;
  travelerEmail: string | null;
  policyNo: string | null;
  travelToDate: string | null;
  travelerAge: string | null;
  isCancelled: string | null;
  cancellationRemarks: string | null;
  responseCode: string | null;
  responseDescription: string | null;
}

export class ProcessUWRequestDataRequest {
  username: string | null;
  password: string | null;
  srvSrce: string | null;
  requestID: string | null;
  isCancelled: boolean;
  cRemarks: string | null;
  eUserName: string | null;
  eSystemName: string | null;
  dataFor: string | null;
}

export class ProcessUWRequestDataResponse {
  requestID: string | null;
  responseCode: string | null;
  responseDescription: string | null;
  policyNo: string | null;
  referenceID: string | null;
  travelerName: string | null;
  amount: string | null;
  advanceTax: string | null;
  policyPrintUrl: string;
  travellerEmail: string;
}

export class GetPolicyReportRequest {
  policyID: number;
  srvSrce: string | null;
}

export class GetPolicyReportResponse {
  clientID: string | null;
  nameOfInsured: string | null;
  dob: string | null;
  passportNo: string | null;
  address: string | null;
  contactNo: string | null;
  beneficiary: string | null;
  relationship: string | null;
  nIC: string | null;
  spouseName: string | null;
  spouseDOB: string | null;
  spousePassportNo: string | null;
  policyID: string | null;
  policyNo: string | null;
  producerName: string | null;
  dateIssued: string | null;
  issuedAt: string | null;
  effectiveDate: string | null;
  expiryDate: string | null;
  countryToTravel: string | null;
  noOfDays: string | null;
  fromCity: string | null;
  toCity: string | null;
  travelDate: string | null;
  premium: string | null;
  planRequired: string | null;
  trip: string | null;
  worldArea: string | null;
  isSingle: string | null;
  childID: string | null;
  childName: string | null;
  childAge: string | null;
  childPassport: string | null;
  noOfPrints: string | null;
  bRCODE: any | null;
  bRCODEImage: any | null;
  advTaxRatePer: string | null;
  advTaxAmount: string | null;
  isTaxDeduct: string | null;
  nTNNo: string | null;
  isTaxNumber: string | null;
  responseCode: string | null;
  responseDescription: string | null;
}

export class GetAllRateAgainstPackageRequest {
  username: string | null;
  password: string | null;
  areaShortCode: string | null;
  srvSrce: string | null;
}

export class GetAllRateAgainstPackageResponse {
  pDAYS: string | null;
  duration: string | null;
  durationUnit: string | null;
  areaShortCode: string | null;
  area: string | null;
  plan: string | null;
  amount: string | null;
  pLANTYPE: string | null;
  responseCode: string | null;
  responseDescription: string | null;
}

export class GetURLForPolicyPrintRequest {
  username: string | null;
  password: string | null;
  policyNo: string | null;
  srvSrce: string | null;
}

export class GetURLForPolicyPrintResponse {
  webUrl: string | null;
  responseCode: string | null;
  responseDescription: string | null;
  policyNo: string | null;
}
export class TravelInsuranceDataProps {
  id: number;
  responseDescription: string;
  bookingId: number;
  requestId: string | null;
  referenceId: string;
  policyNo: string | null;
  insurancePlan: string | null;
  planType: string | null;
  premium: string | null;
  status: string | null;
  policyURL: string;
  travelerName: string;
}
export class UnitedPassengersBaseProperties {
  destinationCountry: string;
  destination: string;
  planType: string;
  isSpousePresent: boolean=false;
  plan: string;
  premium: string;
  noOfDays: number;
  travelDate: string;
  areaShortCode: string;
  remarks: string;
  covid: string = "NotCovered";
  isRequestPolicy: boolean = true;
  referenceNo: string;
  eSystemName: string;
  eUserName: string;
  requestID: string;
  isCancelled: boolean = false;
  dataFor: string = "Pending";
  parentHierarchy: string;
  agencyId: string;
  creationUser: number;
  totalRevenuePremium: string;
  numberOfChildren: number;
  vat: string;
  serviceFee: string;
  taxes: string;
  discount: string;
  markup: string;
  noOfPassengers: number = 1;
  proposalState: number;
  policyNo: string;
  policyURL: string;
  policyPurchaseDate: string;
  children: UnitedChildProperties[] = [];
  // children: string;
  principalTraveller: UnitedPassengerProperties = new UnitedPassengerProperties();
  //beneficiary: UnitedPassengerProperties = new UnitedPassengerProperties();
  //familyMembers: UnitedPassengerProperties[] = [];
}

export class UnitedChildProperties {
  name: string;
  dob: string;
  passport: string;

}
export class UnitedPassengerProperties {
  fullName: string;
  nicNo: string;
  passportNo: string;
  dob: string;
  address: string;
  contactNo: string;
  email: string;
  ntnNo: string;
  ///Beneficiary
  beneficiaryName: string;
  beneficiaryPhone: string;
  beneficiaryAddress: string;
  relationship: string;
        ///Spouse
  spouseName: string;
  spouseDOB: string;
  spousePassport: string;

}
export class InsuranceTypesSwitchProps{
  id: number = 0;
  label: string = "";
  value: string = "";
  isChecked: boolean = false;
  pageLink : string = "";
}
